import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.iconType === 'svg')
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "icon",
        innerHTML: _ctx.iconSVG
      }, null, 8, _hoisted_1))
    : (_ctx.iconType === 'flag' && _ctx.iconSrc)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass(["icon icon--flag", _ctx.iconSrc])
        }, null, 2))
      : _createCommentVNode("", true)
}